import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  /** Rótulo curto mostrado no cabeçalho do aviso (ex.: "Preview Isométrico"). */
  label?: string;
  children: ReactNode;
  /** Conteúdo alternativo. Se ausente, mostra a mensagem de erro. */
  fallback?: ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * Barreira de erro genérica. Sem isto, um throw em qualquer componente
 * desmonta a árvore React inteira (tela branca). Aqui o erro fica CONTIDO
 * na região embrulhada e sua mensagem aparece no lugar — essencial para
 * diagnosticar previews de canvas (CombatGrid) que falham só no browser.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`[ErrorBoundary${this.props.label ? ` · ${this.props.label}` : ''}]`, error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    if (this.props.fallback !== undefined) return this.props.fallback;

    return (
      <div
        style={{
          flex: 1,
          minHeight: 120,
          display: 'flex',
          flexDirection: 'column',
          gap: 6,
          alignItems: 'center',
          justifyContent: 'center',
          padding: 20,
          textAlign: 'center',
          background: '#2a1a1a',
          border: '1px solid #6b2d2d',
          borderRadius: 8,
          color: '#ffb4b4',
        }}
      >
        <strong style={{ fontSize: 13 }}>
          Falha ao renderizar{this.props.label ? `: ${this.props.label}` : ''}
        </strong>
        <code style={{ fontSize: 11, opacity: 0.85, wordBreak: 'break-word' }}>
          {this.state.error.message}
        </code>
      </div>
    );
  }
}
